import moment from 'moment';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setGanttRefAction } from 'data/projects/actions';
import { queueMacrotask } from 'utils/macrotask';
import { TimelineFilterZoomLevel } from './constants';

export const useGanttRef = (showLoader: boolean) => {
  const dispatch = useDispatch();
  const [ganttRef, setGanttRef] = useState<any>(null);
  const [currentZoomLevel, setCurrentZoomLevel] = useState(
    TimelineFilterZoomLevel.Week,
  );

  const collapseAll = useCallback(
    () => ganttRef?.ganttInstance.collapseAll(),
    [ganttRef],
  );
  const expandAll = useCallback(
    () => ganttRef?.ganttInstance.expandAll(),
    [ganttRef],
  );
  const zoomIn = useCallback(() => {
    const gantt = ganttRef?.ganttInstance;

    gantt.zoomIn();
    setCurrentZoomLevel(gantt.zoomLevel);
  }, [ganttRef]);
  const zoomOut = useCallback(() => {
    const gantt = ganttRef?.ganttInstance;

    gantt.zoomOut();
    setCurrentZoomLevel(gantt.zoomLevel);
  }, [ganttRef]);

  const zoomToFit = useCallback(() => {
    const gantt = ganttRef?.ganttInstance;

    gantt.zoomToFit();
    setCurrentZoomLevel(gantt.zoomLevel);
  }, [ganttRef]);

  const shiftPrevious = useCallback(
    () => ganttRef?.ganttInstance.shiftPrevious(),
    [ganttRef],
  );
  const shiftNext = useCallback(
    () => ganttRef?.ganttInstance.shiftNext(),
    [ganttRef],
  );
  const onZoomTo = useCallback(
    (preset: string) => {
      const gantt = ganttRef?.ganttInstance;

      gantt.zoomTo(preset);
      setCurrentZoomLevel(gantt.zoomLevel);
    },
    [ganttRef],
  );

  useEffect(() => {
    queueMacrotask(() => {
      if (ganttRef != null && ganttRef.ganttInstance && !showLoader) {
        ganttRef.ganttInstance.zoomTo({
          level: TimelineFilterZoomLevel.Week,
          centerDate: moment().toDate(),
        });
      }
    });
  }, [ganttRef, showLoader]);

  useEffect(() => {
    if (ganttRef) {
      dispatch(setGanttRefAction(ganttRef));
    }

    return () => {
      dispatch(setGanttRefAction(null));
    };
  }, [dispatch, ganttRef]);

  return {
    ganttRef,
    setGanttRef,
    currentZoomLevel,
    collapseAll,
    expandAll,
    zoomIn,
    zoomOut,
    zoomToFit,
    shiftPrevious,
    shiftNext,
    onZoomTo,
  };
};
